export const BASE_URL="https://us-east1-tqi-backend-2-244713.cloudfunctions.net";
export const BASE_URL2="https://ums.tqi.ai/API";
export const DOWNLOAD_TEMPLATE_URL = "https://storage.cloud.google.com/import_patients/PateintTemplate.xlsx";

// export const Optimization_URL = "https://us-east1-tqi-mobile-web.cloudfunctions.net"


// https://us-east1-tqi-mobile-web.cloudfunctions.net/organizations
